document.addEventListener('DOMContentLoaded', function() {
  const body = document.querySelector('body');
  
  body.addEventListener('click', function(event) {
    // Check if the clicked element is a swatch inside a product card
    if (event.target && event.target.classList.contains('product-card-swatch')) {
      
      const swatch = event.target;
      const productCard = swatch.closest('.product-card');
      
      // Hide the 'on sale' badge
      if (productCard) {
        let mediaImages = productCard.querySelectorAll('.product-card__media img');
        let productTitle = swatch.dataset.productHandle;
        const productTitleElements = productCard.querySelectorAll('[class*="-title"], [class*="title"]');
        let salePriceElement = productCard.getElementsByTagName('sale-price')[0];
        let actualPrice = productCard.getElementsByTagName('sale-price')[0];
        var quickBuyModal = productCard.querySelector('quick-buy-modal');
        const badgeOnSale = productCard.querySelector('.badge--on-sale');
        
        if (badgeOnSale) {
          // Hide the 'on sale' badge if it exists
          badgeOnSale.style.display = 'none';
        }
        // Remove 'active' class from all swatches
        productCard.querySelectorAll('.product-card-swatch').forEach(function(s) {
          s.classList.remove('active');
        });
        // Add 'active' class to the clicked swatch
        swatch.classList.add('active');
        let productUrl = `${window.location.origin}/products/${productTitle}.js`;
        console.log(window.location.origin, 'swatchProduct');
        // Fetch product data
        fetch(productUrl)
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
          })
          .then(data => {
            console.log(data);
            // Update product images
            mediaImages.forEach(function(image, index) {
              if (data.media && data.media[index]) {
                image.setAttribute('src', data.media[index].src);
                image.setAttribute('srcset', data.media[index].src);
              }
            });
            // Update product title elements
            if (productTitleElements && data && data.title) {
              productTitleElements.forEach((element) => {
                element.innerHTML = data.title;
              });
            }
            productCard.querySelector('.product-title').innerHTML = data.title;
            // Update product URLs in anchors
            productCard.querySelectorAll('a').forEach(function(anchor) {
              anchor.setAttribute('href', data.url);
            });
            // Update sale and actual prices
            if (salePriceElement && data && data.price) {
              salePriceElement.innerHTML = ((data.price / 100).toFixed(2));
            }
            if (actualPrice && data && data.compare_at_price) {
              actualPrice.innerHTML = ((data.compare_at_price / 100).toFixed(2));
            }
            // Update quick-buy modal handle
            if (quickBuyModal) {
              var handleValue = data.handle + '?variant=' + data.variants[0].id;
              quickBuyModal.setAttribute('handle', handleValue);
            }
          })
          .catch(error => {
            console.log('There was a problem with the fetch operation:', error);
          });
      }
    }
  });
});